const isTargetingCookiesTypeAccepted = (): boolean => {
  let accepted = false
  accepted = typeof OnetrustActiveGroups !== 'undefined' &&
    OnetrustActiveGroups?.indexOf('C0004') > -1
  return accepted
}

export default isTargetingCookiesTypeAccepted